/**
 * @version:               1.0.0
 * @createTime:            2021.10.08
 * @updateTime:            2021.10.08
 * @author:                zhangju
 * @description
 ***/
export default {
    name: 'content-image',
    props: {
        tab: {
            type: String,
            default: ''
        },
        // 当前组件属于哪个模块
        activePage: {
            type: String,
            default: ''
        },
        hideQuery: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            query: {
                xwbt: null,
                fbrq: null,
                limit: 12
            },
            data: {
                offset: 0,
                limit: 12,
                total: null,
                data: null
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.handleSearch();
        },
        // 点击跳转详情
        handleToDetail(item) {
            const url = this.$router.resolve({path: '/xwzxDetail', query: {active: this.activePage, bh: item.bh}});
            window.open(url.href, '_blank');
            window.console.log(item);
        },
        searchButton() {
            this.query.limit = 12;
            this.query.offset = 0;
            this.handleSearch();
        },
        // 查询
        handleSearch() {
            const queryParams = {
                xwlb: this.tab,
                bt: this.query.xwbt,
                limit: this.query.limit,
                offset: this.query.offset
            };
            if (this.query.fbrq && this.query.fbrq.length > 0) {
                queryParams.fbsjFrom = `${this.query.fbrq[0]} 00:00:00`;
                queryParams.fbsjTo = `${this.query.fbrq[1]} 23:59:59`;
            } else {
                queryParams.fbsjFrom = null;
                queryParams.fbsjTo = null;
            }
            const url = window.fdConfig.url.xwzx.latestXwzxPage;
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: url,
                params: queryParams
            })
                .then((res) => {
                    if (res.data) {
                        this.data = res.data;
                    }
                });
        },
        pageInformation(pageInfo) {
            this.query.limit = pageInfo.limit;
            this.query.offset = pageInfo.offset;
            this.handleSearch();
        },
        // 重置
        handleReset() {
            this.query = {
                xwbt: null,
                fbrq: null
            };
            this.handleSearch();
        }
    }
};
